
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"17","height":"17","fill":"#008CFF","rx":"1"}}),_c('path',{attrs:{"fill":"#fff","d":"M9.899 2.976c.239.514.39 1.14.39 2.056 0 1.675-1.148 4.133-2.08 5.697L7.214 2.46l-4.112.403 1.884 11.618h4.697c2.057-2.792 4.59-6.77 4.59-9.831 0-.96-.194-1.72-.627-2.458z"}})])
          )
        }
      }
    